import { render, staticRenderFns } from "./DateComp.vue?vue&type=template&id=7c4d95a4&scoped=true&"
import script from "./DateComp.vue?vue&type=script&lang=ts&"
export * from "./DateComp.vue?vue&type=script&lang=ts&"
import style0 from "./DateComp.vue?vue&type=style&index=0&id=7c4d95a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d95a4",
  null
  
)

export default component.exports